export default function bubbleUpEvents(event, handlers) {
  handlers.forEach((handler) => {
    if (!event.defaultPrevented && handler !== undefined) {
      handler(event);
    }
  });
}
